import { render, staticRenderFns } from "./try-catch-node.vue?vue&type=template&id=b37ca3d8&scoped=true"
import script from "./try-catch-node.vue?vue&type=script&lang=js"
export * from "./try-catch-node.vue?vue&type=script&lang=js"
import style0 from "./try-catch-node.vue?vue&type=style&index=0&id=b37ca3d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b37ca3d8",
  null
  
)

export default component.exports